const API_BASE = process.env.VUE_APP_BASE_API || (process.env.NODE_ENV === 'development' ? 'https://qingquan.rwan.org.cn/api' : 'https://qingquan.rwan.org.cn/api')
const PLACEHOLDER = '/static/images/wells/placeholder.svg'

function normalizeImagePath(url) {
  if (!url) return ''
  return String(url).trim()
    .replace(/\/wly\/api\/v1(\/images\/)/, '$1')
    .replace(/\/wly(\/images\/)/, '$1')
}

function isInvalidImageUrl(url) {
  if (!url) return true
  const value = normalizeImagePath(url)
  return !value || /^(https?:\/\/)?tmp\//i.test(value) || /example\.com/i.test(value)
}

export function resolveImageUrl(url) {
  if (isInvalidImageUrl(url)) return PLACEHOLDER

  const trimmed = normalizeImagePath(url)
  if (/^https?:\/\//i.test(trimmed)) return trimmed

  if (/^\/static\/images\/wells\/.+\.(png|jpe?g|webp)$/i.test(trimmed)) {
    return PLACEHOLDER
  }

  if (trimmed.startsWith('/static/')) return trimmed

  // /images/... 开头的相对路径直接返回，由 vue.config.js 的代理转发到后端
  // 避免手动拼 API_BASE 绕过代理导致图片 404
  if (trimmed.startsWith('/images/')) {
    return trimmed
  }

  if (trimmed.startsWith('/')) {
    return `${API_BASE}${trimmed}`
  }

  return `${API_BASE}/${trimmed}`
}

export function resolveImageList(list) {
  if (!Array.isArray(list)) return []
  return list.map(item => resolveImageUrl(item)).filter(Boolean)
}

/**
 * 把完整 URL 还原为后端存储的相对路径，供编辑表单提交时使用。
 * 例：http://host/images/abc.jpg → /images/abc.jpg
 */
export function unresolveImageUrl(url) {
  if (!url) return url
  const trimmed = String(url).trim()
  // 以 API_BASE 开头的，去掉前缀
  if (trimmed.startsWith(API_BASE)) {
    return trimmed.slice(API_BASE.length) || '/'
  }
  return trimmed
}

export function unresolveImageList(list) {
  if (!Array.isArray(list)) return []
  return list.map(item => unresolveImageUrl(item)).filter(Boolean)
}
